import styled from 'styled-components'
import { BaseColor, spacing, themeColor, rem } from '~theme'

export const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: ${themeColor(BaseColor.shade_30)};
  border-radius: ${rem(5)};
`

export const Column = styled.ul`
  margin-right: ${spacing(0.5)};
  max-height: ${spacing(10)};
  overflow-y: auto;
  text-align: center;
  padding: ${spacing(0.5)};

  &:last-child {
    margin-right: 0;
  }
`
